import React from "react";
import HeroSection from "../components/HeroSection";
import icons from "../constants/icons.ts";
import { heroSections } from "../constants/data.ts";

const Terms = () => {
  return (
    <main className="bg-background">
      <HeroSection {...heroSections.terms} />

      {/* Effective date */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-12">
            Effective Date: 27/01/2022
          </h2>

          <div className="space-y-6">
            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Acceptance of Terms</h3>
                <p className="text-body">
                  By accessing or using the Westlisoft Technologies Pvt Ltd website (www.westlisoft.com) or any of our services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our Website or services
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Changes to Terms</h3>
                <p className="text-body">
                  Westlisoft Technologies Pvt Ltd may modify these Terms and Conditions at any time. The updated terms will be posted on the Website, and your continued use constitutes acceptance of the revised terms.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Use of the Website</h3>
                <p className="text-body">
                  You may use our Website and services for lawful purposes and in accordance with these Terms and Conditions. You agree not to:
                </p>
                <ul className="list-disc list-inside">
                  <li>Violate any applicable laws or regulations.</li>
                  <li>Infringe upon our intellectual property rights.</li>
                  <li>Transmit any harmful or disruptive content, including malware, viruses, or any other harmful code.</li>
                  <li>Engage in any activity that interferes with or disrupts the functioning of our Website.</li>
                </ul>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Intellectual Property</h3>
                <p className="text-body">
                  All content on our Website, including text, graphics, logos, images, and software, is the property of Westlisoft Technologies Pvt Ltd and is protected by copyright, trademark, and other intellectual property laws. You may not use our content without our explicit written consent.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Links to Third-Party Websites</h3>
                <p className="text-body">
                  Our Website may contain links to third-party websites. These links are provided for your convenience, but we do not endorse or control the content of third-party sites. We are not responsible for the content or practices of these websites.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Limitation of Liability</h3>
                <p className="text-body">
                  We strive to provide accurate and reliable information, but we do not guarantee the accuracy, completeness, or suitability of the content on our Website. We are not liable for any damages or losses resulting from your use of the Website or reliance on its content.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Indemnification</h3>
                <p className="text-body">
                  You agree to indemnify and hold Westlisoft Technologies Pvt Ltd and its affiliates, officers, agents, and employees harmless from any claims, losses, damages, or expenses arising from your use of the Website or any violation of these Terms and Conditions.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Termination</h3>
                <p className="text-body">
                  We reserve the right to terminate or suspend your access to the Website at our discretion without notice for any violation of these Terms and Conditions.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Governing Law and Jurisdiction</h3>
                <p className="text-body">
                  These Terms and Conditions are governed by and construed in accordance with the laws of The Telangana State. Any disputes arising under or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Telangana.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Contact Us</h3>
                <p className="text-body">
                  If you have any questions or concerns about this Website Disclaimer, please contact us at info@westlisoft.com.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default Terms;
